import { useState } from "react";
import * as Icons from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useDoc } from "@/hooks/useDoc";
import { invoicePdf, issueInvoice, DOC_LABEL } from "@/services/invoicesApi";

// Shows the invoice for one record (order / Promise request / milestone): view, download — or
// "Issue invoice" if it hasn't been issued yet. invoiceId: the fixed id (INV-OD-{order} etc.).
// source/sourceId: what to issue it from.
export function InvoiceButton({ invoiceId, source, sourceId, paid = true, className = "" }) {
  const { data: inv, loading } = useDoc("invoices", invoiceId);
  const [busy, setBusy] = useState(false);
  const go = (fn) => async () => { setBusy(true); try { await fn(); } catch (e) { toast.error(e?.response?.data?.detail || e.message); } finally { setBusy(false); } };
  if (loading) return null;
  if (!inv) {
    if (!paid) return null;
    return (
      <Button size="sm" variant="outline" className={className} disabled={busy} data-testid={`issue-invoice-${invoiceId}`}
        onClick={go(async () => { const r = await issueInvoice(source, sourceId); toast.success(`Issued ${r.number}`); })}>
        <Icons.FilePlus2 className="h-3.5 w-3.5 mr-1" />{busy ? "Issuing…" : "Issue invoice"}
      </Button>
    );
  }
  return (
    <span className={`inline-flex items-center gap-1 ${className}`} data-testid={`invoice-${invoiceId}`}>
      <Button size="sm" variant="outline" disabled={busy} onClick={go(() => invoicePdf(inv))} title="View PDF"><Icons.FileText className="h-3.5 w-3.5 mr-1" />{DOC_LABEL[inv.doc_type] || "Invoice"} {inv.number}{inv.status === "credited" ? " (reversed)" : ""}</Button>
      <Button size="icon" variant="ghost" className="h-8 w-8" disabled={busy} onClick={go(() => invoicePdf(inv, true))} title="Download"><Icons.Download className="h-4 w-4" /></Button>
    </span>
  );
}
